import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective } from '../shared/translate.directive';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, TranslateDirective],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.less'
})
export class DashboardComponent {
 


}
